/* eslint-disable no-console */
import ApplicationConf from 'conf/ApplicationConf'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'
import { createAppSlice } from 'common/createAppSlice'
import { aquaFetch } from 'common/utils/ActionUtils'
import { STATUS } from 'common/constants/storeConstants'

const initialState = {
    status: STATUS.IDLE,
    byId: {},
    allIds: [],
}

const CommercialFeaturesSlice = createAppSlice({
    name: 'commercialFeatures',
    initialState,
    reducers: (create) => ({
        reset: create.reducer(() => initialState),

        createCommercialFeature: create.asyncThunk(
            async (commercialFeature, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.admins(), { body: commercialFeature, method: 'POST' })
                    toast.success('Fonctionnalité commercial créée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création d\'une fonctionnalité commercial')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        updateCommercialFeature: create.asyncThunk(
            async (commercialFeature, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.admins(), { body: commercialFeature, method: 'PUT' })
                    toast.success('Fonctionnalité commercial modifiée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la modification d\'une fonctionnalité commercial')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        deleteCommercialFeature: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.admin(id), { method: 'DELETE' })
                    toast.success('Fonctionnalité commercial supprimée avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la suppression d\'une fonctionnalité commercial')
                    return rejectWithValue(err)
                }
            },
            {
                fulfilled: state => {
                    state.status = STATUS.IDLE
                },
            }
        ),
        fetchCommercialFeatures: create.asyncThunk(
            async (_, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.commercialFeatures.admins())
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des fonctionnalités commercials')
                    return rejectWithValue(err)
                }
            },
            {
                pending: state => {
                    state.status = STATUS.LOADING
                },
                rejected: state => {
                    state.status = STATUS.REJECTED
                },
                fulfilled: (state, action) => {
                    state.status = STATUS.SUCCEEDED
                    state.byId = keyBy(action.payload, 'id')
                    state.allIds = action.payload.map(cf => cf.id)
                },
                options: {
                    condition: (_, { getState }) => {
                        const { gdl } = getState()
                        return gdl.commercialFeatures.status === STATUS.IDLE
                    },
                    dispatchConditionRejected: true,
                },
            }
        ),

        fetchAdminFeatureLinks: create.asyncThunk(
            async (id, { rejectWithValue }) => {
                try {
                    return await aquaFetch(ApplicationConf.commercialFeatures.getLinkAdminFeatures(id))
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors du chargement des liens avec les fonctionnalités')
                    return rejectWithValue([])
                }
            }
        ),
        updateLinkAdminFeatures: create.asyncThunk(
            async ({ id, links }, { rejectWithValue }) => {
                try {
                    const response = await aquaFetch(ApplicationConf.commercialFeatures.linkAdminFeatures(id), { body: links, method: 'POST' })
                    toast.success('Liens avec les fonctionnalités créé avec succès')
                    return response
                } catch (err) {
                    console.error(err)
                    toast.error('Erreur lors de la création des liens avec les fonctionnalités')
                    return rejectWithValue(err)
                }
            }
        ),
    }),
    selectors: {
        selectCommercialFeatures: (state) => state.allIds.map(id => state.byId[id]),
    },
})

export const { fetchCommercialFeatures, fetchAdminFeatureLinks, createCommercialFeature, updateCommercialFeature, deleteCommercialFeature, updateLinkAdminFeatures } = CommercialFeaturesSlice.actions
export const { selectCommercialFeatures } = CommercialFeaturesSlice.getSelectors((state) => state.gdl.commercialFeatures)
export default CommercialFeaturesSlice